/**
 * Bruktbil tiers (#673). Presentation only — the API enforces the same split
 * independently. No admin bypass.
 *
 * Its own module for the Fast Refresh reason given in
 * `Leads/eierhistorikk/tilgang.ts`.
 */
import { useAuth } from '../../contexts/AuthContext'
import { hasAnyRole, ROLE_USEDCAR_ADVANCED } from '../../utils/roles'

export function useBruktbilAvansert(): boolean {
  const { user } = useAuth()
  return hasAnyRole(user, [ROLE_USEDCAR_ADVANCED], false)
}
